import { useMemo } from 'react'
import { Button, Dialog, DialogActions, DialogContent, Divider, Stack, Typography } from '@mui/material'
import DraggableDialogTitle from '../../../common/DraggableDialogTitle'
import { ExtraSmallButton } from '../../../custom'
import ClearIcon from '../../../../assets/icons/ClearIcon'
import { useNonModalDialog } from '../../../common/useNonModalDialog'
import MultiStrikeSettingsTabs from '../../../multiStikeChart/chartWrapper/chartMetadata/MultiStrikeSettingsTabs'
import { useFullscreenContainer } from '../../../../hooks/useFullscreenContainer'
import { WidgetSettingsMenuProvider } from '../../widgetSettingsMenuContext'

type Props = {
    open: boolean
    onClose: () => void
    viewKey: string
    /** Trigger button — clicking it while open must not be treated as a click-away. */
    triggerRef?: React.RefObject<HTMLElement | null>
}

const MultiStrikeSettingsDialog = ({ open, onClose, viewKey, triggerRef }: Props) => {
    const clickAwayIgnoreRefs = useMemo(() => (triggerRef ? [triggerRef] : []), [triggerRef])
    const fullscreenContainer = useFullscreenContainer()
    const { dialogProps, paperRef } = useNonModalDialog(open, onClose, { clickAwayIgnoreRefs })

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            container={fullscreenContainer ?? undefined}
            {...dialogProps}
            PaperProps={{
                ref: paperRef,
                sx: { minHeight: '40%', maxHeight: 'max-content', pointerEvents: 'auto' },
            }}
        >
            <DraggableDialogTitle>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">Settings</Typography>
                    <ExtraSmallButton onClick={onClose} aria-label="close" color="inherit">
                        <ClearIcon />
                    </ExtraSmallButton>
                </Stack>
            </DraggableDialogTitle>
            <DialogContent sx={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
                <WidgetSettingsMenuProvider>
                    <MultiStrikeSettingsTabs viewKey={viewKey} />
                </WidgetSettingsMenuProvider>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default MultiStrikeSettingsDialog
